import LegalPage from './LegalPage';
import { fetchPrivacyPolicy } from '../lib/api';

const PrivacyPolicy = () => (
  <LegalPage
    pageKey="privacy"
    fallbackTitle="Privacy Policy"
    fetcher={fetchPrivacyPolicy}
    description="Read EatMeat's Privacy Policy to understand how we handle your personal information and protect your data."
    icon="🔒"
    accentColor="text-blue-600 bg-blue-50 border-blue-100"
  />
);

export default PrivacyPolicy;
